const defaultProcessor = require('./default');

module.exports = function (eventName, eventData) {
  const processChange = !eventData.thumb_src ||
    eventData.smart_load !== false;

  if (!processChange) {
    const deferred = $.Deferred();
    deferred.reject(new Error('Logo update failed'));
    return deferred.promise();
  }

  return defaultProcessor.apply(this, arguments);
};
